module.exports = __webpack_public_path__ + "static/media/c_video.721c3f14.svg";